import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import Icon from 'app/components/UI-Elements/General/Icon'

type Props = {
  member: {
    start_time: string
    return_time: string
  }
}

const KTimeInfo = ({ member }: Props) => {
  const { start_time, return_time } = member || {}

  return (
    <If condition={start_time || return_time}>
      <KTag
        text={`${start_time} - ${return_time}`}
        type="info"
        icon={<Icon iconStyles={{ width: 18, height: 18, verticalAlign: '-0.3em' }} type="time" />}
      />
    </If>
  )
}

export default KTimeInfo
